export const attributesConstants = {
    GET_ATTRIBUTES_REQUEST: 'ATTRIBUTES_GET_ATTRIBUTES_REQUEST',
    GET_ATTRIBUTES_SUCCESS: 'ATTRIBUTES_GET_ATTRIBUTES_SUCCESS',
    GET_ATTRIBUTES_FAILURE: 'ATTRIBUTES_GET_ATTRIBUTES_FAILURE',

    PUT_ATTRIBUTES_REQUEST: 'ATTRIBUTES_PUT_ATTRIBUTES_REQUEST',
    PUT_ATTRIBUTES_SUCCESS: 'ATTRIBUTES_PUT_ATTRIBUTES_SUCCESS',
    PUT_ATTRIBUTES_FAILURE: 'ATTRIBUTES_PUT_ATTRIBUTES_FAILURE',
};